/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import UIkit from 'uikit'
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Text,
  Legend,
} from 'recharts'

// Components
import CustomizedAxisTick from 'app/views/components/CustomizedAxisTick'
import Icon from 'app/views/components/Icon'
import Loader from 'app/views/components/Loader'

// Containers
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

// Redux
import { getClaimedRewardsHistory } from 'app/state/modules/rewards'
import UserDetailModal from 'app/views/components/UserDetailModal'
import GenericModal from 'app/views/components/Modals/GenericModal'


class RewardsReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showAllTime: true,
    }
    this.onDownload = this.onDownload.bind(this)
    this.getRewardType = this.getRewardType.bind(this)
    this.onFilter = this.onFilter.bind(this)
  }

  componentDidMount() {
    this.props.getClaimedRewardsHistory(this.props.match.params.organization_uuid)
  }

  getRewardType(reward) {
    let rewardType
    if (reward.reward.giftCard) {
      rewardType = 'Gift Card'
    } else if (reward.reward.crypto) {
      rewardType = 'Crypto' + ` (${reward.reward.crypto.asset})`
    } else {
      rewardType = 'Not defined'
    }
    return rewardType
  }

  onDownload() {
    const headers = ['email', 'type', 'claimed', 'delivered']
    const rows = []
    rows.push(headers)
    this.props.claimedRewardsHistory.forEach((rewardClaimed) => {
      rows.push([
        rewardClaimed.claimed.metadata.email,
        this.getRewardType(rewardClaimed),
        rewardClaimed.claimed,
        moment(rewardClaimed.claimed.time).format('MMMM DD, YYYY [at] hh:mm A'),
        rewardClaimed.delivered && rewardClaimed.delivered.time ? moment(rewardClaimed.delivered.time).format('YYYY-MM-DD HH:mm') : '-'
      ])
    })
    const csvContent = `data:text/csv;charset=utf-8,${rows.map((e) => {
      return e.join(',')
    }).join('\n')}`
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'HackEDU_rewards_report.csv')
    document.body.appendChild(link)
    link.click()
  }

  onFilter(e) {
    if (e.target.name === '1-year') {
      this.setState({
        showAllTime: false
      }, () => {
        this.props.getClaimedRewardsHistory(
          this.props.match.params.organization_uuid,
          moment().utc().subtract(1, 'year').toISOString(),
          moment().utc().toISOString(),
        )
      })
    } else {
      this.setState({
        showAllTime: true,
      }, () => {
        this.props.getClaimedRewardsHistory(this.props.match.params.organization_uuid)
      })
    }
  }

  render() {
    if (
      !this.props.hasLoadedOrganizations
    ) {
      return <Loader visible />
    }

    return (
      <OrganizationLayout
        active="rewards-report"
        data-test-id="organization-users-component"
        style={{ position: 'relative' }}
        {...this.props}
      >
        {this.props.loadingClaimedRewards ? (
          <Loader visible />
        ) : (
          <>
            <h1 className="uk-margin-remove-bottom">Rewards Report</h1>
            <small>See who has claimed rewards in your HackEDU Rewards program.</small>
            <div className="u-kwidth-3-4">
              <div
                className="uk-margin-top uk-margin-bottom uk-padding uk-position-relative"
                style={{
                  ...(this.props.claimedRewardsHistory.length === 0 ? {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'middle'
                  } : {
                    border: 'solid 1px #c8c8c8',
                    borderRadius: 20,
                    paddingTop: 50
                  })
                }}
              >
                {(this.props.claimedRewardsHistory.length === 0) ? (
                  <p className="uk-text-meta uk-margin-large">
                    No rewards have been claimed.
                  </p>
                ) : (
                  <>
                    <div className="uk-flex uk-flex-right uk-position-absolute uk-flex-middle" style={{ top: 10, right: 10 }}>
                      <button
                        name="all-time"
                        onClick={this.onFilter}
                        className={`uk-button ${this.state.showAllTime ? 'uk-button-primary' : 'uk-button-default'} uk-button-small`}
                      >
                        All Time
                      </button>
                      <button
                        name="1-year"
                        onClick={this.onFilter}
                        className={`uk-button ${!this.state.showAllTime ? 'uk-button-primary' : 'uk-button-default'} uk-button-small uk-margin-small-left`}
                      >
                        1 Year
                      </button>
                    </div>
                    <ResponsiveContainer height={350} className="uk-text-small">
                      <BarChart
                        data={this.props.claimedRewardsChart}
                        margin={{
                          top: 0,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <XAxis
                          height={25}
                          interval={0}
                          dataKey="title"
                        />
                        <YAxis
                          label={(
                            <Text
                              x={-20}
                              y={0}
                              dx={50}
                              dy={200}
                              offset={0}
                              fill="rgb(102, 102, 102)"
                              angle={-90}
                            >
                              Claimed Rewards
                            </Text>
                          )}
                        />
                        <Tooltip
                          content={({ payload }) => {
                            if (payload && payload[0]) {
                              return (
                                <div className="recharts-tooltip-wrapper">
                                  <div
                                    className="recharts-default-tooltip"
                                    style={{
                                      border: 'solid 1px rgb(204, 204, 204)',
                                      backgroundColor: '#fff',
                                      padding: 10,
                                    }}
                                  >
                                    <p
                                      className="recharts-tooltip-label uk-margin-remove-bottom"
                                    >
                                      {payload[0].payload.title}
                                    </p>
                                    <ul
                                      className="uk-nav uk-nav-default uk-margin-small-top"
                                    >
                                      <li style={{ color: '#1e87f0' }}>
                                        <span>
                                          {`${payload[0].payload.Rewards} ${payload[0].payload.Rewards > 1 ? 'rewards' : 'reward'}`}
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )
                            }
                            return null
                          }}
                        />
                        <Bar dataKey="Rewards" stackId="bar" fill="#1e87f0" maxBarSize={20} />
                      </BarChart>
                    </ResponsiveContainer>
                  </>
                )}
              </div>
              {this.props.claimedRewardsHistory.length > 0 && (
                <>
                  <div className="uk-flex uk-flex-right uk-flex-middle uk-margin-top uk-margin-bottom">
                    <button
                      className="uk-button uk-button-primary uk-button-small"
                      onClick={this.onDownload}
                    >
                      Download
                    </button>
                  </div>
                  <div className="uk-card uk-card-body uk-card-default uk-padding-remove">
                    <table className="uk-table uk-table-divider uk-text-small">
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>Reward</th>
                          <th>Claimed</th>
                          <th className="uk-text-center">Delivered</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.claimedRewardsHistory.length === 0 && (
                          <tr>
                            <td colSpan="4" className="uk-text-center">
                              No rewards were claimed yet
                            </td>
                          </tr>
                        )}
                        {this.props.claimedRewardsHistory.map((reward) => {
                          let rewardType
                          rewardType = this.getRewardType(reward)

                          const claimed = moment(reward.claimed.time).format('MMMM DD, YYYY [at] hh:mm A')
                          const { delivered } = reward
                          return (
                            <tr key={reward.uuid}>
                              <td className="uk-width-1-4">
                                {reward.claimed.metadata.email}
                              </td>
                              <td>
                                {rewardType}
                              </td>
                              <td>
                                {claimed}
                              </td>
                              <td className="uk-text-center">
                                {delivered && delivered.time ? (
                                  <Icon
                                    data-uk-tooltip={`title: Delivered on ${moment(delivered.time).format('MMMM DD, YYYY [at] hh:mm A')}`}
                                    className="uk-text-primary"
                                    name="checkbox-circle"
                                    fill
                                  />
                                ) : null}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  hasLoadedOrganizations: state.hacker.hasLoadedOrganizations,
  organizationsHash: state.hacker.organizationsHash,
  organizations: state.hacker.organizationsList,
  claimedRewardsHistory: state.rewards.claimedRewardsHistory,
  loadingClaimedRewards: state.rewards.loadingClaimedRewards,
  claimedRewardsChart: state.rewards.claimedRewardsChart,

})

export default withRouter(connect(mapStateToProps, {
  getClaimedRewardsHistory,
})(RewardsReport))
